const body = document.querySelector('body');
const header = document.querySelector('header');
const main = document.querySelector('main');
const footer = document.querySelector('footer');
const hamburger = document.getElementById('hamburger');
const mainMenu = document.getElementById('main-nav-menu');
const menuFooter = document.getElementById('menu-footer');

function handleClick() {
	let styleDisplay = window.getComputedStyle(mainMenu).display;
	
	if (styleDisplay === 'none') {
		mainMenu.style.display = 'flex';
		menuFooter.style.display = 'initial';
		header.style.minHeight = '100vh';
		header.style.height = '100%';
		header.style.overflow = 'scroll';
		main.style.display = 'none';
		footer.style.display = 'none';
		hamburger.setAttribute('aria-expanded', true);
	} else {
		mainMenu.removeAttribute('style');
		menuFooter.removeAttribute('style');
		header.removeAttribute('style');
		body.removeAttribute('style');
		main.removeAttribute('style');
		footer.removeAttribute('style');
		hamburger.setAttribute('aria-expanded', false);
	}
}

hamburger.addEventListener('click', handleClick);
